import { downloadExcelRequest, formatDate } from "@common";
import { Dispatch } from "redux";
import { all, takeEvery } from "redux-saga/effects";
import { downloadFileFinishedAction, downloadStaticReportFileAction, downloadFileStateError } from "./actions";

function download(dispatch: Dispatch) {
    return function*(action: typeof downloadStaticReportFileAction.typeInterface) {
        try {
            const file: { content: string } = yield* downloadExcelRequest.saga({ campaignId: action.campaignId });

            const dataUriStr = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${
                file.content
            }`;

            const href = document.createElement("a");
            document.body.appendChild(href);
            href.href = dataUriStr; // windowUrl;
            href.download = `Adello-Report-${action.campaignId}-at-${formatDate(new Date())}.xlsx`;
            href.click();
            document.body.removeChild(href);
            dispatch(downloadFileFinishedAction());
        } catch (e) {
            console.error(e);
            dispatch(downloadFileStateError());
        }
    };
}

export function* downloadSaga(dispatch: Dispatch) {
    yield all([takeEvery(downloadStaticReportFileAction.type, download(dispatch))]);
}
